import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import { env } from '~/commons/config';

import {
  PageSchDashBoard,
} from '../pages/dashboards';

const RouteAssignments = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        {env.user.roles.includes('admin') ? (
          <div></div>
        ) : (
          <PageSchDashBoard />
        )}
      </Route>
    </Switch>
  );
};

export default RouteAssignments;
